export default "__VITE_PUBLIC_ASSET__3f1a9532__"